export default __webpack_public_path__ + "static/media/Swimming Complex, Ambala5.301bed7f.jpg";